import { createIcon, Svg } from "@gluestack-ui/icon";
import { G, Path } from "react-native-svg";

const NoResultsIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 453 372",
  path: (
    <>
      <G>
        <Path
          d="M15.5493 170.502V174.338"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <G>
          <Path
            d="M6.93457 172.579L10.069 175.806"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
          <Path
            d="M3.26807 181.169H7.70017"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
          <Path
            d="M6.57422 189.909L9.7087 186.683"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
        </G>
        <Path
          d="M15.5493 190.958V187.122"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M21.943 188.402L19.3857 185.845"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M27.0581 182.01H23.2222"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M24.5006 173.06L21.9434 175.617"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M221.41 3V5.55727"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M213.738 10.6729H216.296"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M221.41 18.3424V15.7852"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M227.803 10.6729H225.246"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M73.0884 110.405V114.241"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M61.5806 121.913H65.4165"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M73.0884 132.142V128.306"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <Path
          d="M83.3169 121.913H79.481"
          stroke="#D2D8DF"
          strokeWidth="1.24496"
          strokeLinecap="round"
        />
        <G>
          <Path
            d="M348.319 249.829C351.375 249.829 353.853 252.308 353.853 255.364C353.853 258.422 351.375 260.9 348.319 260.9C345.263 260.9 342.785 258.422 342.785 255.364"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M373.644 199.609C376.929 198.584 381.966 194.566 383.132 190.242C384.189 194.064 388.621 198.584 392.62 198.926C388.119 200.52 383.815 205.255 383.132 208.975C382.667 205.184 376.714 200.162 373.644 199.609Z"
            fill="#EBECEE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.3545 248.122C37.9979 247.61 40.5152 245.601 41.0982 243.439C41.6268 245.349 43.8423 247.61 45.8418 247.782C43.5916 248.577 41.4401 250.946 41.0982 252.805C40.8659 250.91 37.8894 248.398 36.3545 248.122Z"
            fill="#EBECEE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M66.8535 70.254C66.8535 72.6254 64.9322 74.5462 62.5625 74.5462C60.1917 74.5462 58.2715 72.6254 58.2715 70.254C58.2715 67.8838 60.1917 65.9619 62.5625 65.9619C64.9322 65.9619 66.8535 67.8838 66.8535 70.254Z"
            fill="#D1D8DF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M353.389 81.7783C353.389 85.7404 350.177 88.9521 346.217 88.9521C342.255 88.9521 339.044 85.7404 339.044 81.7783C339.044 77.8163 342.255 74.6045 346.217 74.6045C350.177 74.6045 353.389 77.8163 353.389 81.7783Z"
            fill="#EBECEE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M452.731 62.342C452.731 65.4854 450.184 68.0326 447.043 68.0326C443.9 68.0326 441.354 65.4854 441.354 62.342C441.354 59.1986 443.9 56.6514 447.043 56.6514C450.184 56.6514 452.731 59.1986 452.731 62.342Z"
            fill="#EBECEE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M147.048 328.118C147.048 330.099 145.443 331.705 143.462 331.705C141.482 331.705 139.876 330.099 139.876 328.118C139.876 326.136 141.482 324.53 143.462 324.53C145.443 324.53 147.048 326.136 147.048 328.118Z"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M144.915 42.6798C144.915 45.0512 142.994 46.972 140.624 46.972C138.254 46.972 136.333 45.0512 136.333 42.6798C136.333 40.3095 138.254 38.3877 140.624 38.3877C142.994 38.3877 144.915 40.3095 144.915 42.6798Z"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M254.369 367.843C251.627 368.886 248.558 367.509 247.515 364.767C246.472 362.024 247.848 358.954 250.591 357.911C253.332 356.868 256.401 358.245 257.444 360.987C258.488 363.73 257.111 366.8 254.369 367.843Z"
            stroke="#D2D8DF"
            strokeWidth="1.24496"
            strokeLinecap="round"
          />
        </G>
      </G>
      <G>
        <G>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M289.444 266.399H184.59C177.209 266.399 171.168 260.34 171.168 252.935V103.408C171.168 96.0031 177.209 89.9473 184.59 89.9473H289.444C296.827 89.9473 302.868 96.0031 302.868 103.408V252.935C302.868 260.34 296.827 266.399 289.444 266.399Z"
            fill="#E0E2EE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M280.493 272.791H175.639C168.259 272.791 162.218 266.732 162.218 259.327V109.801C162.218 102.396 168.259 96.3398 175.639 96.3398H280.493C287.876 96.3398 293.917 102.396 293.917 109.801V259.327C293.917 266.732 287.876 272.791 280.493 272.791Z"
            fill="#E8EBF2"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M271.788 277.838H166.717C159.322 277.838 153.268 271.804 153.268 264.43V115.522C153.268 108.148 159.322 102.117 166.717 102.117H271.788C279.186 102.117 285.24 108.148 285.24 115.522V264.43C285.24 271.804 279.186 277.838 271.788 277.838Z"
            fill="#D8DBEA"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M271.788 277.838H166.717C159.322 277.838 153.268 271.804 153.268 264.43V115.522C153.268 108.148 159.322 102.117 166.717 102.117H271.788C279.186 102.117 285.24 108.148 285.24 115.522V264.43C285.24 271.804 279.186 277.838 271.788 277.838Z"
            fill="#F1F2F7"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M256.643 147.485H179.035C176.819 147.485 175.005 145.759 175.005 143.651C175.005 141.539 176.819 139.813 179.035 139.813H256.643C258.859 139.813 260.673 141.539 260.673 143.651C260.673 145.759 258.859 147.485 256.643 147.485Z"
            fill="#E0E2EE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M256.643 170.501H179.035C176.819 170.501 175.005 168.775 175.005 166.666C175.005 164.555 176.819 162.829 179.035 162.829H256.643C258.859 162.829 260.673 164.555 260.673 166.666C260.673 168.775 258.859 170.501 256.643 170.501Z"
            fill="#E0E2EE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M256.643 193.517H179.035C176.819 193.517 175.005 191.791 175.005 189.682C175.005 187.574 176.819 185.845 179.035 185.845H256.643C258.859 185.845 260.673 187.574 260.673 189.682C260.673 191.791 258.859 193.517 256.643 193.517Z"
            fill="#E0E2EE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M256.643 216.532H179.035C176.819 216.532 175.005 214.806 175.005 212.698C175.005 210.586 176.819 208.86 179.035 208.86H256.643C258.859 208.86 260.673 210.586 260.673 212.698C260.673 214.806 258.859 216.532 256.643 216.532Z"
            fill="#E0E2EE"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M219.545 239.548H179.053C176.827 239.548 175.005 237.822 175.005 235.713C175.005 233.602 176.827 231.876 179.053 231.876H219.545C221.771 231.876 223.593 233.602 223.593 235.713C223.593 237.822 221.771 239.548 219.545 239.548Z"
            fill="#E0E2EE"
          />
        </G>
      </G>
    </>
  ),
});

NoResultsIcon.displayName = "NoResultsIcon";
export { NoResultsIcon };
